// signInReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  usernameError: false,
  usernameErrorMessage: '',
  passwordError: false,
  passwordErrorMessage: '',
  username: 'ysyu5502',
  password: '1122-AAbb',
  credential: null,
};

const signInSlice = createSlice({
  name: 'signIn',
  initialState,
  reducers: {
    setCredential(state, action) {
      state.credential = action.payload;
    },
    setUsernameError(state, action) {
      state.usernameError = action.payload;
    },
    setUsernameErrorMessage(state, action) {
      state.usernameErrorMessage = action.payload;
    },
    setPasswordError(state, action) {
      state.passwordError = action.payload;
    },
    setPasswordErrorMessage(state, action) {
      state.passwordErrorMessage = action.payload;
    },
    setUsername(state, action) {
      state.username = action.payload;
    },
    setPassword(state, action) {
      state.password = action.payload;
    },
    reset4SignIn() {
      return initialState;
    },
  },
});

export const { setCredential, setUsernameError, setUsernameErrorMessage, setPasswordError, setPasswordErrorMessage, setUsername, setPassword, reset4SignIn } = signInSlice.actions;
export default signInSlice.reducer;
// const initialState = {
//     usernameError: false,
//     usernameErrorMessage: '',
//     passwordError: false,
//     passwordErrorMessage: '',
//     username: 'yeuksze02',
//     password: '1122-AAbb',
//     //loading4SignIn: false,
//     credential: null,
// };

// export default function signInReducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setCredential':
//       return {
//         ...state,
//         credential: action.payload,
//       };    
//     // case 'setLoading4SignIn':
//     //   return {
//     //     ...state,
//     //     loading4SignIn: action.payload,
//     //   };
//     case 'setUsernameError':
//       return {
//         ...state,
//         usernameError: action.payload,
//       };
//     case 'setUsernameErrorMessage':
//       return {
//         ...state,
//         usernameErrorMessage: action.payload,
//       };     
//     case 'setPasswordError':
//       return {
//         ...state,
//         passwordError: action.payload,
//       };  
//     case 'setPasswordErrorMessage':
//       return {
//         ...state,
//         passwordErrorMessage: action.payload,
//       };  
//     case 'setUsername':
//       return {
//         ...state,
//         username: action.payload,
//       };  
//     case 'setPassword':
//       return {
//         ...state,
//         password: action.payload,
//       };             
//     case 'reset4SignIn':
//       return initialState;                          
//     default:
//       return state;
//   }
// }

// export const setCredential = (e) => ({
//   type: 'setCredential',
//   payload: e,
// });

// // export const setLoading4SignIn = (e) => ({
// //   type: 'setLoading4SignIn',
// //   payload: e,
// // });

// export const setUsernameError = (e) => ({
//   type: 'setUsernameError',
//   payload: e,
// });

// export const setUsernameErrorMessage = (e) => ({
//   type: 'setUsernameErrorMessage',
//   payload: e,
// });

// export const setPasswordError  = (e) => ({
//   type: 'setPasswordError',
//   payload: e,
// });

// export const setPasswordErrorMessage  = (e) => ({
//   type: 'setPasswordErrorMessage',
//   payload: e,
// });

// export const setUsername  = (e) => ({
//   type: 'setUsername',
//   payload: e,
// });

// export const setPassword  = (e) => ({
//   type: 'setPassword',
//   payload: e,
// });

// export const reset4SignIn  = (e) => ({
//   type: 'reset4SignIn',
//   payload: e,
// });